import { NUMBERS, LETTERS, SYMBOLS, DISPLAY_MODES } from './constants';
import { CwTrainer } from './cwTrainer';


export default class BaseCWTrainer {


    constructor(wpm, farnsworthWpm, useLetters, useNumbers, useSymbols, totalCharRepeats, displayMode, onDisplay) {

        this.wpm = wpm;
        this.farnsworthWpm = farnsworthWpm;
        this.useLetters = useLetters;
        this.useNumbers = useNumbers;
        this.useSymbols = useSymbols;        
        this.onDisplay = onDisplay;
        this.totalCharRepeats = totalCharRepeats;
        this.shouldStop = false;

        CwTrainer.getInstance().setWpm(this.wpm, this.farnsworthWpm);

        this.setDisplayMode(displayMode);        
    }

    setDisplayMode(displayMode){}

    _getTextToSend() { return '';    }

    setUseLetters(useLetters) {this.useLetters = useLetters;}
    setUseNumbers(useNumbers) {this.useLetters = useNumbers;}
    setUseSymbols(useSymbols) {this.useLetters = useSymbols;}

    setWpm(wpm) {
        this.wpm = wpm;
        CwTrainer.getInstance().setWpm(this.wpm, this.farnsworthWpm);
    }

    setFarnsworthWpm(farnsworthWpm) {
        this.farnsworthWpm = farnsworthWpm;
        CwTrainer.getInstance().setWpm(this.wpm, this.farnsworthWpm);
    }

    setTotalCharRepeats(totalCharRepeats) { 
        this.totalCharRepeats = totalCharRepeats;        
    }

    resetCwTrainerCallbacks() {
        CwTrainer.getInstance().setBeforeCharCallback(false);
        CwTrainer.getInstance().setAfterCharCallback(false);        
        CwTrainer.getInstance().setAfterSendCallback(false);        
        CwTrainer.getInstance().setAfterCancelCallback(false);
    }

    play() {
        this.shouldStop = false;
        CwTrainer.getInstance().setAfterSendCallback(() => {
            if(!this.shouldStop) CwTrainer.getInstance().sendText(this._getTextToSend());        
        });
        CwTrainer.getInstance().sendText(this._getTextToSend());    
    }

    stop() { 
        this.shouldStop = true;
        CwTrainer.getInstance().cancel();
        this.onDisplay('');
    }


};